import { useImageUrlBuilder, ImageOptions } from './useImageUrlBuilder';


export const useDefaultAgentCoverImageUrl = (options?: ImageOptions): string => {
  const builder = useImageUrlBuilder();
  const imagePlaceholderIdx = Math.floor(Math.random() * 3 + 1);
  const path = `agents/agent-page-empty-state-bg${imagePlaceholderIdx !== 1 ? `-${imagePlaceholderIdx}` : ''}.png`;
  return builder(path, options);
};
